(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('RaceResume', RaceResume);

    RaceResume.$inject = ['$resource', 'DateUtils'];

    function RaceResume ($resource, DateUtils) {
        var resourceUrl =  'api/race-resumes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.finishDate = DateUtils.convertDateTimeFromServer(data.finishDate);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
